var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.activeStat),callback:function ($$v) {_vm.activeStat=$$v},expression:"activeStat"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("EditCountry"))+" ")]),_c('v-card-text',[_c('EditCountryForm',{attrs:{"item":_vm.item},on:{"edited":_vm.OnResult}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }